import { Checkbox } from "../checkbox/Checkbox";
import { CheckboxProps } from "../checkbox/CheckboxProps";
import { Image } from "../image/Image";
import { ImageName } from "@mcleod/images";
import { ImageProps } from "../image/ImageProps";

export class SelectTableRowCheckbox extends Checkbox {
    constructor(props?: Partial<CheckboxProps>) {
        super({
            padding: 0,
            color: "primary",
            ...props
        });
    }

    protected override createImage(props: Partial<ImageProps>): Image {
        return new SelectTableRowCheckboxImage({
            ...props,
            width: 36,
            height: 36,
            padding: 0
        });
    }
}

class SelectTableRowCheckboxImage extends Image {
    // Image.name builds the element and sets the viewBox of the SVG and any nested SVGs to the standard 24x24.
    // Reapply a larger viewBox on the nested SVG to render the icon at ~15x15
    // while the clickable area remains 36x36.
    override set name(value: ImageName) {
        super.name = value;
        const innerSvg = this._element.querySelector("svg");
        innerSvg?.setAttribute("viewBox", "-9.6 -9.6 43.2 43.2");
    }

    override get name(): ImageName {
        return super.name;
    }
}
